var SCM = SCM || {};

(function ($, ns) {
    ns.registerToggle = function () {
        function toggleDropdown($trigger) {
            var $wrap = $trigger.closest('.js-history-dropdown-wrap');
            var $menu = $wrap.find('.js-history-entries-wrap');

            $menu.toggleClass('expanded');
        }

        $(document.body).on('click', '.js-history-dropdown-trigger', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown($(this));
        });

        $(document.body).on('click', function (e) {
            if ($(e.target).closest('.js-history-dropdown-wrap').length === 0) {
                $('.js-history-entries-wrap:visible').toggleClass('expanded');
            }
        });
    };
})(jQuery, SCM.PubHistory = SCM.PubHistory || {});
